/* ProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ProfileCardWrapper.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  wrapper: "_1bsb1gwv"
};
export var ProfileCardWrapper = function ProfileCardWrapper(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.wrapper,
    testId: testId
  }, children);
};